'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global espn window */


var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// this is the key .com uses for local storage of fanapi data
var ESPN_FAN_STORAGE_KEY = 'fanapi_fan';
var StorageType = {
    ESPN: 'ESPN',
    LOCAL_STORAGE: 'LOCAL_STORAGE'
};

var ls = {
    getItem: function getItem(key) {
        return _bluebird2.default.resolve(JSON.parse(localStorage.getItem(key)));
    },
    setItem: function setItem(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    }
};

/**
 * @class {Storage} - This class uses ESPN storage if available, and local storage if not
 */

var Storage = function () {
    /**
     * @constructor
     * @param {int} expiration - expiration of storage in minutes
     */
    function Storage() {
        var expiration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;

        _classCallCheck(this, Storage);

        this.expiration = expiration;
        // default to localstorage.  we will infer storage type at the time [get/set]Fan is called
        this.storageType = StorageType.LOCAL_STORAGE;
    }

    /**
     * This function sets appropriate properties if ESPN storage is available.  Does not set it twice if already determined.
     */


    _createClass(Storage, [{
        key: 'inferStorageType',
        value: function inferStorageType() {
            if (this.storageType !== StorageType.ESPN && window && window.espn && window.espn.storageFactory) {
                this.storageType = StorageType.ESPN;
                this.espnStorage = espn.storageFactory.getMostPermanent();
            }
        }
    }, {
        key: 'getFan',
        value: function getFan() {
            var _this = this;

            this.inferStorageType();
            if (this.storageType === StorageType.ESPN) {
                return new _bluebird2.default(function (resolve, reject) {
                    var cache = _this.espnStorage.getItem(ESPN_FAN_STORAGE_KEY);
                    var fan = cache && cache.item;
                    if (fan) {
                        // keep local storage in sync with espn storage
                        ls.setItem(ESPN_FAN_STORAGE_KEY, {
                            item: fan,
                            id: fan.id,
                            timestamp: Date.now()
                        });
                        resolve(cache);
                    } else {
                        reject(new Error('No item for key'));
                    }
                });
            }
            return ls.getItem(ESPN_FAN_STORAGE_KEY);
        }

        /**
         * @param {object} fan - The fan to replace the current cache
         */

    }, {
        key: 'setFan',
        value: function setFan(fan) {
            this.inferStorageType();
            // always set local storage cache
            ls.setItem(ESPN_FAN_STORAGE_KEY, {
                item: fan.item,
                id: fan.id,
                timestamp: Date.now()
            });

            // only set espn storage if present
            if (this.storageType === StorageType.ESPN) {
                this.espnStorage.setItem(ESPN_FAN_STORAGE_KEY, {
                    item: fan.item,
                    id: fan && fan.id,
                    expiresAt: new Date().getTime() + this.expiration * 60000
                });
            }
        }
    }]);

    return Storage;
}();

exports.default = Storage;


//////////////////
// WEBPACK FOOTER
// ./~/watch-fanapi/dist/Storage.js
// module id = 812
// module chunks = 0